export const environment = {
  production: false,
  envName: 'develop',
  baseUrl: 'https://authoritie-develop-api.b5digital.dk',
  domainUrl: 'https://authoritie-develop.b5digital.dk',
  rollbarAccessToken: 'b54adf226858444db458cd15995d5f38',
  appName: 'Authoritie - Development',
  stripePublishableKey: 'pk_test_51RWDZPH0GxNMoial1ZtHPLcA0iUjcnLjZDQdR0UOYOCGtBxRsvdpxRAG944qsQDprvQCU6dY3VZLNVCKn2NlqZIy00b8vscJyW',
  turnstileSiteKey: '0x4AAAAAACKqmZ82NRdcmRfh',
}; 